<script setup lang="ts">
import { useCompanyScopeSync } from "@/remote/useCompanyScopeSync";

/** Headless: exists so the sync runs from a component App mounts after `router.isReady()`. */
useCompanyScopeSync();
</script>

<template>
  <!-- nothing to render; this component only follows the host's scope -->
</template>
